import React from 'react';
import Icon from './forms/Icon';
import { statusColors } from './utility/functions';

const CheckMark = ({ checked, ...props }) => (
    <Icon
        icon={checked ? 'check' : 'cross'}
        style={{ color: checked ? statusColors.Active : statusColors.NotValidated }}
        {...props}
    />
)


export default CheckMark;
